<template>
    <v-container>
        <v-form
            v-model="valid"
            ref="form"
            lazy-validation
        >
        <v-row>
            <v-col cols="12" sm="8">
                 <v-row>
                    <v-col
                        cols="12"
                        sm="4"
                    >
                    <v-menu v-model="menu" offset-y :close-on-content-click="false">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-on="on"
                                label="Arrival date"
                                v-model="payload.arrival"
                                outlined
                                :rules="textRules"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="picker" @click="menu = false" :min="nowDate"></v-date-picker>
                    </v-menu>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="4"
                    >
                        <v-select
                            :items="rooms"
                            v-model="chooseRoom"
                            label="Room type"
                            item-text="name"
                            item-value="id"
                            outlined
                            @change="personMax"
                            :rules="textRules"
                        ></v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="4"
                    >
                        <v-select
                            :items="durations"
                            v-model="chooseDate"
                            item-text="name"
                            item-value="id"
                            label="I want to book a Panchakarma for"
                            outlined
                            :rules="textRules"
                        ></v-select>
                    </v-col>
                </v-row>
                <!-- guest 1 -->
                <v-row>
                    <v-col
                        cols="12"
                    >
                        <h2 v-if="payload.max==1">Guest</h2>
                        <h2 v-else>First Guest</h2>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="4"
                    >
                        <v-select
                            :items="titles"
                            v-model="payload.guest1.title"
                            label="Title"
                            outlined
                            :rules="textRules"
                        ></v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="4"
                    >
                        <v-text-field
                                label="First Name"
                                v-model="payload.guest1.first"
                                outlined
                                :rules="textRules"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="4"
                    >
                        <v-text-field
                                label="Last Name"
                                v-model="payload.guest1.last"
                                outlined
                                :rules="textRules"
                        ></v-text-field>
                    </v-col>
                    <!-- list 2 -->
                    <v-col
                        cols="12"
                        sm="6"
                    >
                        <v-select
                            :items="country"
                            v-model="payload.guest1.country"
                            item-text="name"
                            label="Country of origin"
                            outlined
                            :rules="textRules"
                        ></v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                    >
                        <v-text-field
                                label="Mobile phone number"
                                v-model="payload.guest1.phone"
                                outlined
                                :rules="textRules"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                    >
                        <v-text-field
                                label="Email address"
                                v-model="payload.guest1.email"
                                outlined
                                :rules="emailRules"
                        ></v-text-field>
                    </v-col>
                    <!-- list 3 -->
                    <v-col
                        cols="12"
                        sm="6"
                    >
                        <v-select
                            :items=pkbefore
                            v-model="payload.guest1.pkbefore"
                            label="Have you done a Panchakarma before?"
                            outlined
                            :rules="textRules"
                        ></v-select>
                    </v-col>
                    <v-col
                        cols="12"
                    >
                        <v-textarea
                            outlined
                            v-model="payload.guest1.health"
                            label="Do you have any serious health issues that we should be aware of before your arrival?"
                            :rules="textRules"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <!-- guest 2 -->
                <v-row v-if="payload.max==2">
                    <v-col
                        cols="12"
                    >
                        <h2>Second Guest</h2>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="4"
                    >
                        <v-select
                            :items="titles"
                            v-model="payload.guest2.title"
                            label="Title"
                            outlined
                            :rules="textRules"
                        ></v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="4"
                    >
                        <v-text-field
                                label="First Name"
                                v-model="payload.guest2.first"
                                outlined
                                :rules="textRules"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="4"
                    >
                        <v-text-field
                                label="Last Name"
                                v-model="payload.guest2.last"
                                outlined
                                :rules="textRules"
                        ></v-text-field>
                    </v-col>
                    <!-- list 2 -->
                    <v-col
                        cols="12"
                        sm="6"
                    >
                        <v-select
                            :items="country"
                            v-model="payload.guest2.country"
                            item-text="name"
                            label="Country of origin"
                            outlined
                            :rules="textRules"
                        ></v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                    >
                        <v-text-field
                                label="Mobile phone number"
                                v-model="payload.guest2.phone"
                                outlined
                                :rules="textRules"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                    >
                        <v-text-field
                                label="Email address"
                                v-model="payload.guest2.email"
                                outlined
                                :rules="emailRules"
                        ></v-text-field>
                    </v-col>
                    <!-- list 3 -->
                    <v-col
                        cols="12"
                        sm="6"
                    >
                        <v-select
                            :items=pkbefore
                            v-model="payload.guest2.pkbefore"
                            label="Have you done a Panchakarma before?"
                            outlined
                            :rules="textRules"
                        ></v-select>
                    </v-col>
                    <v-col
                        cols="12"
                    >
                        <v-textarea
                            outlined
                            v-model="payload.guest2.health"
                            label="Do you have any serious health issues that we should be aware of before your arrival?"
                            :rules="textRules"
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" sm="4">
                <PaymentForm :price="payload.price" :paymentData="payload" :valid="valid" :coba="$refs.form" />
            </v-col>
        </v-row>
        </v-form>
    </v-container>
</template>
<script>
import PaymentForm from './PaymentForm.vue';
export default {
    name: 'BookingForm',
  data() {
    return {
      menu: false,
      valid: true,
      payload: {
        price:0,
        max:1,
        arrival: '',
        room:'',
        duration:'',
        paymentMethods:'',
        channel:'',
        guest1:{
            "title":"",
            "first": "",
            "last": "",
            "country":"",
            "phone":"",
            "email":"",
            "pkbefore": "",
            "health":""
        },
        guest2:{
            "title":"",
            "first": "",
            "last": "",
            "country":"",
            "phone":"",
            "email":"",
            "pkbefore": "",
            "health":""
        }
      },
      pkbefore: ["Yes", "No"],
      rooms: [ 
        {   
            id: 1,
            name: 'Single occupancy',
            products: [
                {
                    id: 1,
                    price: 17000,
                    name: '07 nigths'
                },
                {
                    id: 2,
                    price: 110000,
                    name: '10 nigths'
                },
                {
                    id: 3,
                    price: 114000,
                    name: '14 nigths'
                },
                {
                    id: 4,
                    price: 121000,
                    name: '21 nigths'
                },
                {
                    id: 5,
                    price: 128000,
                    name: '28 nigths'
                }
            ]
        },
        {
            id: 2,
            name: 'Double occupancy (1 bed)',
            products: [
                {
                    id: 1,
                    price: 27000,
                    name: '07 nigths'
                },
                {
                    id: 2,
                    price: 210000,
                    name: '10 nigths'
                },
                {
                    id: 3,
                    price: 214000,
                    name: '14 nigths'
                },
                {
                    id: 4,
                    price: 221000,
                    name: '21 nigths'
                },
                {
                    id: 5,
                    price: 228000,
                    name: '28 nigths'
                }
            ]
        },
        {
            id: 3,
            name: 'Twin share (2 beds)',
            products: [
                {
                    id: 1,
                    price: 27000,
                    name: '07 nigths'
                },
                {
                    id: 2,
                    price: 210000,
                    name: '10 nigths'
                },
                {
                    id: 3,
                    price: 214000,
                    name: '14 nigths'
                },
                {
                    id: 4,
                    price: 221000,
                    name: '21 nigths'
                },
                {
                    id: 5,
                    price: 228000,
                    name: '28 nigths'
                }
            ]
        }
      ],
      nowDate: new Date().toISOString().slice(0,10),
      country:[ 
  {name: 'Afghanistan', code: 'AF'}, 
  {name: 'Åland Islands', code: 'AX'}, 
  {name: 'Albania', code: 'AL'}, 
  {name: 'Algeria', code: 'DZ'}, 
  {name: 'American Samoa', code: 'AS'}, 
  {name: 'AndorrA', code: 'AD'}, 
  {name: 'Angola', code: 'AO'}, 
  {name: 'Anguilla', code: 'AI'}, 
  {name: 'Antarctica', code: 'AQ'}, 
  {name: 'Antigua and Barbuda', code: 'AG'}, 
  {name: 'Argentina', code: 'AR'}, 
  {name: 'Armenia', code: 'AM'}, 
  {name: 'Aruba', code: 'AW'}, 
  {name: 'Australia', code: 'AU'}, 
  {name: 'Austria', code: 'AT'}, 
  {name: 'Azerbaijan', code: 'AZ'}, 
  {name: 'Bahamas', code: 'BS'}, 
  {name: 'Bahrain', code: 'BH'}, 
  {name: 'Bangladesh', code: 'BD'}, 
  {name: 'Barbados', code: 'BB'}, 
  {name: 'Belarus', code: 'BY'}, 
  {name: 'Belgium', code: 'BE'}, 
  {name: 'Belize', code: 'BZ'}, 
  {name: 'Benin', code: 'BJ'}, 
  {name: 'Bermuda', code: 'BM'}, 
  {name: 'Bhutan', code: 'BT'}, 
  {name: 'Bolivia', code: 'BO'}, 
  {name: 'Bosnia and Herzegovina', code: 'BA'}, 
  {name: 'Botswana', code: 'BW'}, 
  {name: 'Bouvet Island', code: 'BV'}, 
  {name: 'Brazil', code: 'BR'}, 
  {name: 'British Indian Ocean Territory', code: 'IO'}, 
  {name: 'Brunei Darussalam', code: 'BN'}, 
  {name: 'Bulgaria', code: 'BG'}, 
  {name: 'Burkina Faso', code: 'BF'}, 
  {name: 'Burundi', code: 'BI'}, 
  {name: 'Cambodia', code: 'KH'}, 
  {name: 'Cameroon', code: 'CM'}, 
  {name: 'Canada', code: 'CA'}, 
  {name: 'Cape Verde', code: 'CV'}, 
  {name: 'Cayman Islands', code: 'KY'}, 
  {name: 'Central African Republic', code: 'CF'}, 
  {name: 'Chad', code: 'TD'}, 
  {name: 'Chile', code: 'CL'}, 
  {name: 'China', code: 'CN'}, 
  {name: 'Christmas Island', code: 'CX'}, 
  {name: 'Cocos (Keeling) Islands', code: 'CC'}, 
  {name: 'Colombia', code: 'CO'}, 
  {name: 'Comoros', code: 'KM'}, 
  {name: 'Congo', code: 'CG'}, 
  {name: 'Congo, The Democratic Republic of the', code: 'CD'}, 
  {name: 'Cook Islands', code: 'CK'}, 
  {name: 'Costa Rica', code: 'CR'}, 
  {name: 'Cote D\'Ivoire', code: 'CI'}, 
  {name: 'Croatia', code: 'HR'}, 
  {name: 'Cuba', code: 'CU'}, 
  {name: 'Cyprus', code: 'CY'}, 
  {name: 'Czech Republic', code: 'CZ'}, 
  {name: 'Denmark', code: 'DK'}, 
  {name: 'Djibouti', code: 'DJ'}, 
  {name: 'Dominica', code: 'DM'}, 
  {name: 'Dominican Republic', code: 'DO'}, 
  {name: 'Ecuador', code: 'EC'}, 
  {name: 'Egypt', code: 'EG'}, 
  {name: 'El Salvador', code: 'SV'}, 
  {name: 'Equatorial Guinea', code: 'GQ'}, 
  {name: 'Eritrea', code: 'ER'}, 
  {name: 'Estonia', code: 'EE'}, 
  {name: 'Ethiopia', code: 'ET'}, 
  {name: 'Falkland Islands (Malvinas)', code: 'FK'}, 
  {name: 'Faroe Islands', code: 'FO'}, 
  {name: 'Fiji', code: 'FJ'}, 
  {name: 'Finland', code: 'FI'}, 
  {name: 'France', code: 'FR'}, 
  {name: 'French Guiana', code: 'GF'}, 
  {name: 'French Polynesia', code: 'PF'}, 
  {name: 'French Southern Territories', code: 'TF'}, 
  {name: 'Gabon', code: 'GA'}, 
  {name: 'Gambia', code: 'GM'}, 
  {name: 'Georgia', code: 'GE'}, 
  {name: 'Germany', code: 'DE'}, 
  {name: 'Ghana', code: 'GH'}, 
  {name: 'Gibraltar', code: 'GI'}, 
  {name: 'Greece', code: 'GR'}, 
  {name: 'Greenland', code: 'GL'}, 
  {name: 'Grenada', code: 'GD'}, 
  {name: 'Guadeloupe', code: 'GP'}, 
  {name: 'Guam', code: 'GU'}, 
  {name: 'Guatemala', code: 'GT'}, 
  {name: 'Guernsey', code: 'GG'}, 
  {name: 'Guinea', code: 'GN'}, 
  {name: 'Guinea-Bissau', code: 'GW'}, 
  {name: 'Guyana', code: 'GY'}, 
  {name: 'Haiti', code: 'HT'}, 
  {name: 'Heard Island and Mcdonald Islands', code: 'HM'}, 
  {name: 'Holy See (Vatican City State)', code: 'VA'}, 
  {name: 'Honduras', code: 'HN'}, 
  {name: 'Hong Kong', code: 'HK'}, 
  {name: 'Hungary', code: 'HU'}, 
  {name: 'Iceland', code: 'IS'}, 
  {name: 'India', code: 'IN'}, 
  {name: 'Indonesia', code: 'ID'}, 
  {name: 'Iran, Islamic Republic Of', code: 'IR'}, 
  {name: 'Iraq', code: 'IQ'}, 
  {name: 'Ireland', code: 'IE'}, 
  {name: 'Isle of Man', code: 'IM'}, 
  {name: 'Israel', code: 'IL'}, 
  {name: 'Italy', code: 'IT'}, 
  {name: 'Jamaica', code: 'JM'}, 
  {name: 'Japan', code: 'JP'}, 
  {name: 'Jersey', code: 'JE'}, 
  {name: 'Jordan', code: 'JO'}, 
  {name: 'Kazakhstan', code: 'KZ'}, 
  {name: 'Kenya', code: 'KE'}, 
  {name: 'Kiribati', code: 'KI'}, 
  {name: 'Korea, Democratic People\'S Republic of', code: 'KP'}, 
  {name: 'Korea, Republic of', code: 'KR'}, 
  {name: 'Kuwait', code: 'KW'}, 
  {name: 'Kyrgyzstan', code: 'KG'}, 
  {name: 'Lao People\'S Democratic Republic', code: 'LA'}, 
  {name: 'Latvia', code: 'LV'}, 
  {name: 'Lebanon', code: 'LB'}, 
  {name: 'Lesotho', code: 'LS'}, 
  {name: 'Liberia', code: 'LR'}, 
  {name: 'Libyan Arab Jamahiriya', code: 'LY'}, 
  {name: 'Liechtenstein', code: 'LI'}, 
  {name: 'Lithuania', code: 'LT'}, 
  {name: 'Luxembourg', code: 'LU'}, 
  {name: 'Macao', code: 'MO'}, 
  {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'}, 
  {name: 'Madagascar', code: 'MG'}, 
  {name: 'Malawi', code: 'MW'}, 
  {name: 'Malaysia', code: 'MY'}, 
  {name: 'Maldives', code: 'MV'}, 
  {name: 'Mali', code: 'ML'}, 
  {name: 'Malta', code: 'MT'}, 
  {name: 'Marshall Islands', code: 'MH'}, 
  {name: 'Martinique', code: 'MQ'}, 
  {name: 'Mauritania', code: 'MR'}, 
  {name: 'Mauritius', code: 'MU'}, 
  {name: 'Mayotte', code: 'YT'}, 
  {name: 'Mexico', code: 'MX'}, 
  {name: 'Micronesia, Federated States of', code: 'FM'}, 
  {name: 'Moldova, Republic of', code: 'MD'}, 
  {name: 'Monaco', code: 'MC'}, 
  {name: 'Mongolia', code: 'MN'}, 
  {name: 'Montserrat', code: 'MS'}, 
  {name: 'Morocco', code: 'MA'}, 
  {name: 'Mozambique', code: 'MZ'}, 
  {name: 'Myanmar', code: 'MM'}, 
  {name: 'Namibia', code: 'NA'}, 
  {name: 'Nauru', code: 'NR'}, 
  {name: 'Nepal', code: 'NP'}, 
  {name: 'Netherlands', code: 'NL'}, 
  {name: 'Netherlands Antilles', code: 'AN'}, 
  {name: 'New Caledonia', code: 'NC'}, 
  {name: 'New Zealand', code: 'NZ'}, 
  {name: 'Nicaragua', code: 'NI'}, 
  {name: 'Niger', code: 'NE'}, 
  {name: 'Nigeria', code: 'NG'}, 
  {name: 'Niue', code: 'NU'}, 
  {name: 'Norfolk Island', code: 'NF'}, 
  {name: 'Northern Mariana Islands', code: 'MP'}, 
  {name: 'Norway', code: 'NO'}, 
  {name: 'Oman', code: 'OM'}, 
  {name: 'Pakistan', code: 'PK'}, 
  {name: 'Palau', code: 'PW'}, 
  {name: 'Palestinian Territory, Occupied', code: 'PS'}, 
  {name: 'Panama', code: 'PA'}, 
  {name: 'Papua New Guinea', code: 'PG'}, 
  {name: 'Paraguay', code: 'PY'}, 
  {name: 'Peru', code: 'PE'}, 
  {name: 'Philippines', code: 'PH'}, 
  {name: 'Pitcairn', code: 'PN'}, 
  {name: 'Poland', code: 'PL'}, 
  {name: 'Portugal', code: 'PT'}, 
  {name: 'Puerto Rico', code: 'PR'}, 
  {name: 'Qatar', code: 'QA'}, 
  {name: 'Reunion', code: 'RE'}, 
  {name: 'Romania', code: 'RO'}, 
  {name: 'Russian Federation', code: 'RU'}, 
  {name: 'RWANDA', code: 'RW'}, 
  {name: 'Saint Helena', code: 'SH'}, 
  {name: 'Saint Kitts and Nevis', code: 'KN'}, 
  {name: 'Saint Lucia', code: 'LC'}, 
  {name: 'Saint Pierre and Miquelon', code: 'PM'}, 
  {name: 'Saint Vincent and the Grenadines', code: 'VC'}, 
  {name: 'Samoa', code: 'WS'}, 
  {name: 'San Marino', code: 'SM'}, 
  {name: 'Sao Tome and Principe', code: 'ST'}, 
  {name: 'Saudi Arabia', code: 'SA'}, 
  {name: 'Senegal', code: 'SN'}, 
  {name: 'Serbia and Montenegro', code: 'CS'}, 
  {name: 'Seychelles', code: 'SC'}, 
  {name: 'Sierra Leone', code: 'SL'}, 
  {name: 'Singapore', code: 'SG'}, 
  {name: 'Slovakia', code: 'SK'}, 
  {name: 'Slovenia', code: 'SI'}, 
  {name: 'Solomon Islands', code: 'SB'}, 
  {name: 'Somalia', code: 'SO'}, 
  {name: 'South Africa', code: 'ZA'}, 
  {name: 'South Georgia and the South Sandwich Islands', code: 'GS'}, 
  {name: 'Spain', code: 'ES'}, 
  {name: 'Sri Lanka', code: 'LK'}, 
  {name: 'Sudan', code: 'SD'}, 
  {name: 'Suriname', code: 'SR'}, 
  {name: 'Svalbard and Jan Mayen', code: 'SJ'}, 
  {name: 'Swaziland', code: 'SZ'}, 
  {name: 'Sweden', code: 'SE'}, 
  {name: 'Switzerland', code: 'CH'}, 
  {name: 'Syrian Arab Republic', code: 'SY'}, 
  {name: 'Taiwan, Province of China', code: 'TW'}, 
  {name: 'Tajikistan', code: 'TJ'}, 
  {name: 'Tanzania, United Republic of', code: 'TZ'}, 
  {name: 'Thailand', code: 'TH'}, 
  {name: 'Timor-Leste', code: 'TL'}, 
  {name: 'Togo', code: 'TG'}, 
  {name: 'Tokelau', code: 'TK'}, 
  {name: 'Tonga', code: 'TO'}, 
  {name: 'Trinidad and Tobago', code: 'TT'}, 
  {name: 'Tunisia', code: 'TN'}, 
  {name: 'Turkey', code: 'TR'}, 
  {name: 'Turkmenistan', code: 'TM'}, 
  {name: 'Turks and Caicos Islands', code: 'TC'}, 
  {name: 'Tuvalu', code: 'TV'}, 
  {name: 'Uganda', code: 'UG'}, 
  {name: 'Ukraine', code: 'UA'}, 
  {name: 'United Arab Emirates', code: 'AE'}, 
  {name: 'United Kingdom', code: 'GB'}, 
  {name: 'United States', code: 'US'}, 
  {name: 'United States Minor Outlying Islands', code: 'UM'}, 
  {name: 'Uruguay', code: 'UY'}, 
  {name: 'Uzbekistan', code: 'UZ'}, 
  {name: 'Vanuatu', code: 'VU'}, 
  {name: 'Venezuela', code: 'VE'}, 
  {name: 'Viet Nam', code: 'VN'}, 
  {name: 'Virgin Islands, British', code: 'VG'}, 
  {name: 'Virgin Islands, U.S.', code: 'VI'}, 
  {name: 'Wallis and Futuna', code: 'WF'}, 
  {name: 'Western Sahara', code: 'EH'}, 
  {name: 'Yemen', code: 'YE'}, 
  {name: 'Zambia', code: 'ZM'}, 
  {name: 'Zimbabwe', code: 'ZW'} 
        ],
      durations:[],
      titles:[
        "Mr",
        "Mrs",
        "Ms",
      ],
      textRules: [
        v => !!v || 'This field is required',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    };
  },
//   mounted() {
//     console.log(this.$refs.form.validate())
//   },
  methods: {
    personMax() {
        if (this.payload.room != 'Single occupancy') {
            this.payload.max = 2
        } else {
            this.payload.max = 1
        }
    },
    paymentProcess(payload) {
        this.$store.dispatch('setPayload', payload)
        this.$router.push({ path: '/confirmation'})
    }
  },
  computed: {
    picker: {
      get() {
        return this.value;
      },
      set(val) {
        this.menu = false;
        this.payload.arrival = val
      }
    },
    chooseRoom: {
        get() {
            return this.value
        },
        set(val) {
            var data = this.rooms.find(r => r.id == val)
            this.payload.room = data.name
            if (this.payload.price > 0) {
                this.payload.price = 0
            }
            this.durations= data.products
        }
    },
    chooseDate: {
        get() {
            return this.value
        },
        set(val) {
            var data = this.durations.find(r => r.id == val)
            this.payload.duration = data.name
            this.payload.price = data.price
        }
    }
  },
  components: {
    PaymentForm
  }
};
</script>